export const getOrgId = (clubName: string) => {
	switch (clubName) {
		case "vnca":
			return "dbdc8244-d7bb-439f-a620-190aa5303145";
		case "thomastown":
			return "0e0641c4-87d8-eb11-a7ad-2818780da0cc";
		case "himalayan":
			return "3a59d145-87d8-eb11-a7ad-2818780da0cc";
		case "donath":
			return "2eaabf0e-87d8-eb11-a7ad-2818780da0cc";
		case "prestondruids":
			return "75db3fd0-87d8-eb11-a7ad-2818780da0cc";
		case "coburg":
			return "477a9e9b-86d8-eb11-a7ad-2818780da0cc";
		case "frankstonpeninsula":
			return "ef0a02d2-86d8-eb11-a7ad-2818780da0cc";
		case "bbl":
			return "48e680a0-b1dc-eb11-a7ad-501ac52e1bf9";
		case "australia":
			return "f615d93f-87d8-eb11-a7ad-2818780da0cc";
		default:
			return "";
	}
};
